<template>
  <div
    id="template-type-2"
    class="template-container p-0 bg-cover"
    :class="[
      {
        'editor-inactive':
          editorSelectId && editorSelectId == 'templateBgEditor',
      },
      { 'editor-hide-bg': !isActive },
    ]"
    :style="{
      'background-image': `url(${templateDataObj.backgroundImg.url})`,
    }"
    @click.self="isActive ? onSelect('templateBgEditor') : () => {}"
  >
    <template-tool
      v-if="
        templateDataObj.isLayoutBgShow &&
        editorSelectId &&
        editorSelectId == 'templateBgEditor' &&
        templateDataObj.backgroundImg.url
      "
      :isReorder="false"
      :isHideTool="isActive"
      customRemoveIconClass="align-items-start"
      customReorderIconClass="align-items-start"
      @onRemove="onSelect('templateBgEditor', true)"
    />
    <div
      class="
        template-wrp
        no-shadow
        d-flex
        flex-column
        bg-white
        border-raduis-0
        pt-2
        user-select-none
      "
      :class="[{ bypass: !isActive }]"
    >
      <div
        class="position-relative mb-1 no-reorder"
        :class="[
          {
            'editor-inactive':
              editorSelectId && editorSelectId == 'templateLogoEditor',
          },
          { 'editor-hide': !isActive },
        ]"
        @click="onSelect('templateLogoEditor')"
      >
        <template-tool
          v-if="
            templateDataObj.isLayoutLogoShow &&
            editorSelectId &&
            editorSelectId == 'templateLogoEditor' &&
            templateDataObj.logoImg.url
          "
          :isReorder="false"
          :isHideTool="isActive"
          @onRemove="onSelect('templateLogoEditor', true)"
        />
        <logo-code-template :form-modal="templateDataObj" />
      </div>
      <div class="group-text-header">
        <div
          v-if="templateDataObj.templateContentWrp[0]"
          :id="templateDataObj.templateContentWrp[0].key"
          :style="[
            templateDataObj.templateContentWrp[0]
              ? resolveStyle(templateDataObj.templateContentWrp[0])
              : null,
          ]"
          class="position-relative coupon-name mb-1"
          :class="[
            {
              'editor-active':
                editorSelectId &&
                editorSelectId == templateDataObj.templateContentWrp[0].key,
            },
            { 'editor-hide': !isActive },
          ]"
          @click="onSelect(templateDataObj.templateContentWrp[0].key)"
        >
          <template-tool
            v-if="
              templateDataObj.templateContentWrp[0].isShow &&
              templateDataObj.templateContentWrp[0].text &&
              editorSelectId &&
              editorSelectId == templateDataObj.templateContentWrp[0].key
            "
            class="reorder-template-content"
            :isHideTool="isActive"
            @onRemove="
              onSelect(templateDataObj.templateContentWrp[0].key, true)
            "
          />
          <div
            class="text-custom text-editor-custom"
            :style="[
              templateDataObj.templateContentWrp[0]
                ? resolveStyle(templateDataObj.templateContentWrp[0])
                : null,
            ]"
            v-safe-html="templateDataObj.templateContentWrp[0].text"
          />
        </div>
      </div>
      <div
        class="position-relative mb-1 bypass"
        v-if="templateDataObj.privilegeUploadImg.url"
      >
        <image-code-template
          :image-url="templateDataObj.privilegeUploadImg.url"
        />
      </div>
      <div class="position-relative mb-1 bypass" v-else>
        <image-code-template :image-url="templateDataObj.privilegeImg.url" />
      </div>
      <div class="group-text-body">
        <div
          v-if="templateDataObj.templateContentWrp[1]"
          :id="templateDataObj.templateContentWrp[1].key"
          :style="[
            templateDataObj.templateContentWrp[1]
              ? resolveStyle(templateDataObj.templateContentWrp[1])
              : null,
          ]"
          class="position-relative coupon-desc mb-1"
          :class="[
            {
              'editor-active':
                editorSelectId &&
                editorSelectId == templateDataObj.templateContentWrp[1].key,
            },
            { 'editor-hide': !isActive },
          ]"
          @click="onSelect(templateDataObj.templateContentWrp[1].key)"
        >
          <template-tool
            v-if="
              templateDataObj.templateContentWrp[1].isShow &&
              templateDataObj.templateContentWrp[1].text &&
              editorSelectId &&
              editorSelectId == templateDataObj.templateContentWrp[1].key
            "
            class="reorder-template-content"
            :isHideTool="isActive"
            @onRemove="
              onSelect(templateDataObj.templateContentWrp[1].key, true)
            "
          />
          <div
            class="text-custom text-editor-custom"
            :style="[
              templateDataObj.templateContentWrp[1]
                ? resolveStyle(templateDataObj.templateContentWrp[1])
                : null,
            ]"
            v-safe-html="templateDataObj.templateContentWrp[1].text"
          />
        </div>
        <div
          v-if="templateDataObj.templateContentWrp[2]"
          :id="templateDataObj.templateContentWrp[2].key"
          :style="[
            templateDataObj.templateContentWrp[2]
              ? resolveStyle(templateDataObj.templateContentWrp[2])
              : null,
          ]"
          class="position-relative expire-date"
          :class="[
            {
              'editor-active':
                editorSelectId &&
                editorSelectId == templateDataObj.templateContentWrp[2].key,
            },
            { 'editor-hide': !isActive },
          ]"
          @click="onSelect(templateDataObj.templateContentWrp[2].key)"
        >
          <template-tool
            v-if="
              templateDataObj.templateContentWrp[2].isShow &&
              templateDataObj.templateContentWrp[2].text &&
              editorSelectId &&
              editorSelectId == templateDataObj.templateContentWrp[2].key
            "
            class="reorder-template-content"
            :isHideTool="isActive"
            @onRemove="
              onSelect(templateDataObj.templateContentWrp[2].key, true)
            "
          />
          <div
            class="text-custom text-editor-custom"
            :style="[
              templateDataObj.templateContentWrp[2]
                ? resolveStyle(templateDataObj.templateContentWrp[2])
                : null,
            ]"
            v-safe-html="templateDataObj.templateContentWrp[2].text"
          />
        </div>
      </div>
      <div class="qr-code-template no-reorder render">
        <code-template
          :codeColor="resolveColor"
          :codeTextColor="resolveTextColor"
        />
      </div>
      <div
        class="
          remark-template
          position-relative
          d-flex
          justify-content-center
          no-reorder
        "
        :class="[
          {
            'editor-active':
              editorSelectId && editorSelectId == 'remarkTextEditer',
          },
          { 'editor-hide': !isActive },
          { 'remark-template-hide': !templateDataObj.privilegeRemark },
        ]"
      >
        <div
          v-if="templateDataObj.privilegeRemark"
          class="remark-template-bg"
          :style="{ backgroundColor: resolveBgRemark }"
          @click="onSelect('remarkTextEditer')"
        >
          <template-tool
            v-if="
              templateDataObj.isLayoutRemarkShow &&
              templateDataObj.privilegeRemark &&
              editorSelectId &&
              editorSelectId == 'remarkTextEditer'
            "
            :isReorder="false"
            :isHideTool="isActive"
            @onRemove="onSelect('remarkTextEditer', true)"
          />
          <div
            class="text-custom text-editor-custom remark-editer"
            :style="[
              templateDataObj.remarkTextEditer
                ? resolveRemarkStyle(templateDataObj.remarkTextEditer)
                : null,
            ]"
            v-safe-html="templateDataObj.privilegeRemark"
          />
        </div>
      </div>
      <div class="group-text-footer mb-1">
        <div
          v-if="templateDataObj.templateContentWrp[3]"
          :id="templateDataObj.templateContentWrp[3].key"
          :class="[
            {
              'editor-active':
                editorSelectId &&
                editorSelectId == templateDataObj.templateContentWrp[3].key,
            },
            { 'editor-hide': !isActive },
          ]"
          @click="onSelect(templateDataObj.templateContentWrp[3].key)"
          class="position-relative term-condition"
        >
          <template-tool
            v-if="
              templateDataObj.templateContentWrp[3].isShow &&
              templateDataObj.templateContentWrp[3].text &&
              editorSelectId &&
              editorSelectId == templateDataObj.templateContentWrp[3].key
            "
            class="reorder-template-content"
            :isHideTool="isActive"
            @onRemove="
              onSelect(templateDataObj.templateContentWrp[3].key, true)
            "
          />
          <div
            class="text-custom text-editor-custom"
            :style="[
              templateDataObj.templateContentWrp[3]
                ? resolveStyle(templateDataObj.templateContentWrp[3])
                : null,
            ]"
            v-safe-html="templateDataObj.templateContentWrp[3].text"
          />
        </div>
      </div>
      <div
        class="
          template-footer
          d-flex
          justify-content-center
          mt-auto
          mb-footer
          bypass
        "
      >
        <img :src="logoChoco" class="logo-choco" />
      </div>
    </div>
  </div>
</template>

<script>
import logoChoco from "@/assets/images/logo/logo-choco.png";
import ExpandableTextLine from "vue-expandable-text-line";
import ImageCodeTemplate from "../modal/ImageCodeTemplate.vue";
import LogoCodeTemplate from "../modal/LogoCodeTemplate.vue";
import CodeTemplate from "../modal/CodeTemplate.vue";

import TemplateTool from "./TemplateTool.vue";

import useTemplateComponent from "../../hooks/useTemplateComponent";

export default {
  components: {
    LogoCodeTemplate,
    ImageCodeTemplate,
    CodeTemplate,
    ExpandableTextLine,
    TemplateTool,
  },
  props: {
    templateData: { type: [Object, Array], default: null },
    editorData: { type: Object, default: null },
    editorSelectId: null,
    isActive: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      templateDataObj,
      onSelect,
      resolveDate,
      resolveTime,
      resolveStyle,
      resolveExpireDate,
      resolveColor,
      resolveTextColor,
      resolveBgRemark,
      resolveRemarkStyle,
    } = useTemplateComponent(props);

    return {
      templateDataObj,
      logoChoco,
      onSelect,
      resolveDate,
      resolveTime,
      resolveStyle,
      resolveExpireDate,
      resolveColor,
      resolveTextColor,
      resolveBgRemark,
      resolveRemarkStyle,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/template.css";

.template-ptb {
  padding: 1rem 0;
}

.border-raduis-0 {
  border-radius: unset !important;
}

.p-unset {
  padding: unset !important;
}
</style>
